import publicHttpClient from 'api/publicHttpClient';
import { AxiosRequestConfig } from 'axios';
import { UploadedFileResponse } from 'models/File';
import { AuthBody } from 'models/AuthBody';
import { UpdateEnterpriseMember } from 'models/Enterprises';
import { getFileParams, getUploadedFile } from 'uploadFileUtils';

function getMember(token: string) {
  return publicHttpClient.get(`enterprise-members/${token}`);
}

function publishMember(
  token: string,
  data: Partial<UpdateEnterpriseMember> & { password: string },
) {
  return publicHttpClient.post<AuthBody>(
    `enterprise-members/${token}/publish-onboard`,
    data,
  );
}

async function uploadProfileImage(
  file: File,
  fileName: string,
  memberId: string,
  config?: AxiosRequestConfig,
) {
  const fileParams = getFileParams(fileName, file);

  const { data } = await publicHttpClient.post<UploadedFileResponse>(
    `enterprise-members/${memberId}/upload-temporary-object`,
    fileParams,
  );

  return await getUploadedFile(data, file, config);
}

function deleteProfileImage(
  fileName: string,
  fileId: string,
  memberId: string,
) {
  return publicHttpClient.delete<{ fileId: string }>(
    `enterprise-members/${memberId}/files/${fileName}/${fileId}`,
  );
}

export default {
  getMember,
  uploadProfileImage,
  deleteProfileImage,
  publishMember,
};
